// extracted by mini-css-extract-plugin
export default {"tabs":"SCALSetting_tabs__O6Qf-","parentTabs":"SCALSetting_parentTabs__Ch4w5"};